import { render, staticRenderFns } from "./team.vue?vue&type=template&id=003af706&lang=html&"
import script from "./team.vue?vue&type=script&lang=ts&"
export * from "./team.vue?vue&type=script&lang=ts&"
import style0 from "./team.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports